import { render, staticRenderFns } from "./RecordCreator.vue?vue&type=template&id=016d1cdc&scoped=true"
import script from "./RecordCreator.vue?vue&type=script&lang=js"
export * from "./RecordCreator.vue?vue&type=script&lang=js"
import style0 from "./RecordCreator.vue?vue&type=style&index=0&id=016d1cdc&prod&scoped=true&lang=scss"
import style1 from "./RecordCreator.vue?vue&type=style&index=1&id=016d1cdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016d1cdc",
  null
  
)

export default component.exports